
import randomColor from "randomcolor";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TileHead extends Vue {
  @Prop(Boolean) readonly avatar!: boolean;
  @Prop(String) readonly image!: string;
  @Prop(String) readonly initial!: string;
  @Prop(String) readonly title!: string;
  @Prop(String) readonly subtitle!: string;
  @Prop(String) readonly badge!: string;
  @Prop(String) readonly color!: string;

  initialColor() {
    return randomColor({
      luminosity: "dark",
    });
  }
}
